import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Box, Button, Divider, Typography } from "@mui/material";
import { useCurrencyCode } from "../../genericComponents/helper-functions/CurrencySymbol";

interface MinimumPriceAlertProps {
  openInfo: any;
  handleClose: any;
}

const MinimumPriceAlert: React.FC<MinimumPriceAlertProps> = ({
  openInfo,
  handleClose,
}) => {
  const currencyCode = useCurrencyCode();

  return (
    <React.Fragment>
      <Dialog
        open={openInfo}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              variant="body1"
              sx={{ color: "red", fontWeight: "bold" }}
            >
              Warning
            </Typography>
          </Box>
          <br />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="body1" sx={{ color: "black" }}>
              Minimum checkout amount is {currencyCode}480
            </Typography>
          </Box>
          <br />
          <Box
            sx={{
              display: "flex",
              justifyContent: "right",
              alignItems: "center",
            }}
          >
            <Button variant="contained" color="success" onClick={handleClose}>
              ok
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default MinimumPriceAlert;
